import React from 'react';
import ReactDOM from 'react-dom';
import './assets/style/global.scss';
import './assets/i18n/i18n.ts';
import App from './pages/App/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './providers/Auth';
import { LicenseInfo } from '@mui/x-license-pro';
import Amplify, { Auth } from 'aws-amplify';
import { ApiErrorProvider } from './providers/ApiErrorProvider';
import { ACWindow } from "./helpers/analyticsHelper";
import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

/* 
*  TODO: Once the license is acquired, 
*        uncomment the following line and replace the key with the acquired license key
*/
LicenseInfo.setLicenseKey(
  `${process.env.REACT_APP_MATERIAL_UI_LICENSE_KEY}`
);

declare global {
  interface Window extends ACWindow { }
}

//load dynamic scripts
function loadScripts() {
  const dynamicScripts = [`${process.env.REACT_APP_ADOBE_ANALYTICS}`];
  for (let i = 0; i < dynamicScripts.length; i++) {
    const node = document.createElement('script');
    node.src = dynamicScripts[i];
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USERPOOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_AWS_domain,
      redirectSignIn: `${window.location.origin}/`,
      redirectSignOut: `${window.location.origin}/`,
      responseType: "code"
    },
  },
  API: {
    endpoints: [
      {
        name: "crewlife",
        endpoint: process.env.REACT_APP_API_BASE,
        custom_header: async () => {
          return {
            "Authorization": `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
            "Content-Type": "application/json",
            "Accept": "*/*"
          };
        }
      },
      {
        name: "crewlife-upload",
        endpoint: process.env.REACT_APP_UPLOAD_API_BASE,
        custom_header: async () => {
          return {
            "Authorization": `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
          };
        }
      }
    ]
  }
});

const configuration: Configuration = {
  auth: {
      clientId: `${process.env.REACT_APP_OUTLOOK_ENT_CLIENT_ID}`,
      authority: process.env.REACT_APP_OUTLOOK_ENT_LOGIN,
      redirectUri: '/settings'
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  }
};
const pca = new PublicClientApplication(configuration);
const outlookAuthCodeChannel = new BroadcastChannel('outlook-authcode');

loadScripts();

if(window.location.hash !== '') {
  console.log("hash found" + window.location.hash);
} else {
  ReactDOM.render(
    <React.StrictMode>
      <AuthProvider outlookAuthCodeChannel={outlookAuthCodeChannel}>     
        <Router>
          <ApiErrorProvider>
            <MsalProvider instance={pca}>
              <App outlookAuthCodeChannel={outlookAuthCodeChannel}/>
            </MsalProvider>
          </ApiErrorProvider>
        </Router>
      </AuthProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
